import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstDepartmentService {
    mstDepartment: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'mst_department/list/?';
    private DeactiveListRecord = webapi + 'mst_department/deactiveList/?';
    private AddRecord = webapi + 'mst_department/create';
    private EditRecord = webapi + 'mst_department/update';
    private GetRecord = webapi + 'mst_department/byid/';
    private DeleteRecord = webapi + 'mst_department/delete/';
    private ReActiveRecord = webapi + 'mst_department/reActive/';
    private ListRecorddepartment = webapi + 'mst_department/medicaldepartment/?';
    private departmentListByUnitId = webapi + 'mst_department/departmentListByUnitId';
    private ListbyunitRecord = webapi + 'mst_department/byunitid/';
    private ListbyunitAndIsmedicaldepartmentRecord = webapi + 'mst_department/byunitidAndIsMedicaldepartment/';
    private ListbyunitAndIsnonmedicaldepartmentRecord = webapi + 'mst_department/byunitidAndIsNonMedicaldepartment/';
    private ListRecorddepartmentForConfigByUnitId = webapi + 'mst_department/byunitid/';
    private GetDropDown = webapi + 'mst_department/dropdown?';
    private GetByunitidmedicaldepartment = webapi + 'mst_department/byunitidmedicaldepartment/';
    private AuthorizedListRecord = webapi + 'mst_department/getAuthorizedDepartmentList/?';



    constructor(
        private http: Http
    ) {
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.DeactiveListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllAuthoriedDepRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.AuthorizedListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getlistbyunitService(unitid: any): Promise<any> {
        return this.http.get(this.ListbyunitRecord + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getlistbyunitAndisMedicalService(unitid: any): Promise<any> {
        return this.http.get(this.ListbyunitAndIsmedicaldepartmentRecord + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getlistbyunitAndisNonMedicalService(unitid: any): Promise<any> {
        return this.http.get(this.ListbyunitAndIsnonmedicaldepartmentRecord + unitid)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getDepartmentListByUnitId(unitListJson: any): Promise<any> {
        return this.http.post(this.departmentListByUnitId, unitListJson, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordServicemedicaldepartment(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecorddepartment + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordServicemedicaldepartmentForConfigByUnitId(unitId: any): Promise<any> {
        return this.http.get(this.GetByunitidmedicaldepartment + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllDropDown(currentPage: any, size: any, globalFilter: any, unitId: any): Promise<any> {
        return this.http.get(this.GetDropDown + 'page=' + currentPage + '&size=' + size + '&globalFilter=' + globalFilter + '&unitId=' + unitId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-department/mst-department.service.ts